import * as React from "react";
const SvgCheckButton = props => <svg xmlns="http://www.w3.org/2000/svg" width={10} height={7} fill="none" viewBox="0 0 10 7" {...props}><path stroke="#9C4DFF" strokeLinecap="round" strokeLinejoin="round" d="M9 1 3.5 6.5 1 4" /></svg>;
export default SvgCheckButton;